import {category$, categoryChanged, searchTerms$, searchTermsChanged} from './index';

category$.on(categoryChanged, (state, category) => category);
searchTerms$.on(searchTermsChanged, (state, searchTerm) => searchTerm);
